import { useEffect, useState, useContext } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { sendAPIRequest } from "helpers";
import CustomCard from "components/common/CustomCard";
import CardBody from "components/common/CardBody";
import Loader from "components/spinner/Loader";
import { Row } from "react-bootstrap";
import Column from "components/common/Column";
import { Tabs, Tab, Accordion, AccordionSummary, AccordionDetails, IconButton } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import TabPanel from "pages/frontend/components/staffComponents/TabPanel";
import DataTable from "pages/components/DataTable";
import { empty } from "helpers";
import moment from "moment";
import MissionHeader from "./mission/MissionHeader";
import Crumbs from "components/crumbs/Crumbs";
import { MissionContext } from "modules/pvs_activities/components/contexts/MissionTasksContext";

const EmailNotificationLogs = () => {

    const [emailData, setEmailData] = useState([]);
    const [notificationData, setNotificationData] = useState([]);
    const [missionHistoryData, setMissionHistoryData] = useState([]);
    const [documentHistoryData, setDocumentHistoryData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [value, setValue] = useState(0);

    const [emailAccordion, setEmailAccordion] = useState(true);
    const [notificationAccordion, setNotificationAccordion] = useState(true);
    const [missionHistoryLoading, setMissionHistoryLoading] = useState(false);
    const [documentHistoryLoading, setDocumentHistoryLoading] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();

    const { id } = useParams();
    const { t } = useTranslation();

    const toggleEmailAccordion = () => setEmailAccordion((prev) => !prev);
    const toggleNotificationAccordion = () => setNotificationAccordion((prev) => !prev);

    useEffect(() => {
        loadEmailLogs();
        loadNotificationsLogs();
        loadMissionHistoryLogs();
        loadDocumentHistoryLogs();
        const tab = searchParams.get("tab");
        if (tab === "email") setValue(1);
        else if (tab === "mission-history") setValue(2);
        else if (tab === "document-history") setValue(3);
        else setValue(0);
    }, []);

    const handleChange = (_, newValue) => {
        setValue(newValue);
        if (newValue === 0) {
            loadNotificationsLogs();
            setSearchParams({ tab: "notifications" });
        } else if (newValue === 1) {
            loadEmailLogs();
            setSearchParams({ tab: "email" });
        } else if (newValue === 2) {
            loadMissionHistoryLogs();
            setSearchParams({ tab: "mission-history" });
        } else if (newValue === 3) {
            loadDocumentHistoryLogs();
            setSearchParams({ tab: "document-history" });
        }
    };

    const loadEmailLogs = async () => {
        try {
            const ret = await sendAPIRequest(`/api/pvsa/activity_logs/?log_type=email&mission_id=${id}`);
            const res = await ret.json();
            if (res.success && res.status === 200) {
                setEmailData(res.data);
            }
        } catch (err) {
            console.log({ err });
        }
    };

    const loadNotificationsLogs = async () => {
        try {
            const ret = await sendAPIRequest(`/api/pvsa/activity_logs/?log_type=notification&mission_id=${id}`);
            const res = await ret.json();
            if (res.success && res.status === 200) {
                setNotificationData(res.data);
            }
        } catch (err) {
            console.log({ err });
        }
    };

    const loadMissionHistoryLogs = async () => {
        setMissionHistoryLoading(true);
        try {
            const ret = await sendAPIRequest(`/api/pvsa/activity_logs/mission-history?mission_id=${id}`);
            const res = await ret.json();
            if (res.success && res.status === 200) {
                setMissionHistoryData(res.data);
            }
        } catch (err) {
            console.log({ err });
        } finally {
            setMissionHistoryLoading(false);
        }
    };

    const loadDocumentHistoryLogs = async () => {
        setDocumentHistoryLoading(true);
        try {
            const ret = await sendAPIRequest(`/api/pvsa/activity_logs/document-history?mission_id=${id}`);
            const res = await ret.json();
            if (res.success && res.status === 200) {
                setDocumentHistoryData(res.data);
            }
        } catch (err) {
            console.log({ err });
        } finally {
            setDocumentHistoryLoading(false);
        }
    };

    return (
        <div className="container my-2">
            <CustomCard className="shadow-sm my-3 bg-white">
                <CardBody>
                    {isLoading ? (
                        <Loader message="Loading..." className="text-muted ms-3" />
                    ) : (
                        <Row className="d-flex justify-content-center">
                            <Column className="text-center d-flex justify-content-center align-items-center" col={12}>
                                <Tabs value={value} onChange={handleChange}>
                                    <Tab className="fw-bold fs-5" label="Notification Logs" value={0} />
                                    <Tab className="fw-bold fs-5" label="Email Logs" value={1} />
                                    <Tab className="fw-bold fs-5" label="Mission History Logs" value={2} />
                                    <Tab className="fw-bold fs-5" label="Document History Logs" value={3} />
                                </Tabs>
                            </Column>
                        </Row>)}
                </CardBody>
            </CustomCard>

            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <TabPanel value={value} index={0}>
                        <div className="pb-2">
                            <Accordion expanded={notificationAccordion} style={{ border: "1px solid lightgray" }}>
                                <AccordionSummary
                                    expandIcon={
                                        <IconButton onClick={toggleNotificationAccordion}>
                                            {emailAccordion ? (
                                                <RemoveCircleIcon sx={{ color: "#FF7954" }} />
                                            ) : (
                                                <AddCircleIcon sx={{ color: "#FF7954" }} />
                                            )}
                                        </IconButton>
                                    }
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                    className="fs-4"
                                >
                                    <div className="d-flex px-1 w-100 ">
                                        <div className="card-title1 lh-1">{t("-1", "Notifications Log")}</div>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className="card card-woah border border-secondary shadow rounded-0 mt-0">
                                        <div className="card-body p-4">
                                            <DataTable
                                                getRowId={(row) => row.id}
                                                isLoading={false}
                                                className="text-white bg-primary rounded-0"
                                                rows={notificationData}
                                                columns={[
                                                    {
                                                        field: "sr",
                                                        headerName: t("-1", "#"),
                                                        headerClassName: "text-white bg-primary rounded-0",
                                                        flex: 1,
                                                    },
                                                    {
                                                        field: "subject",
                                                        headerName: t("-1", "Subject"),
                                                        headerClassName: "text-white bg-primary rounded-0",
                                                        minWidth: 150,
                                                        flex: 1,
                                                    },
                                                    {
                                                        field: "from",
                                                        headerName: t("-1", "Notification From"),
                                                        headerClassName: "text-white bg-primary rounded-0",
                                                        minWidth: 100,
                                                        flex: 1,
                                                    },
                                                    {
                                                        field: "to",
                                                        headerName: t("-1", "Notification To"),
                                                        headerClassName: "text-white bg-primary rounded-0",
                                                        minWidth: 100,
                                                        flex: 1,
                                                    },
                                                    {
                                                        field: "body",
                                                        headerName: t("-1", "Notification Content"),
                                                        headerClassName: "text-white bg-primary rounded-0",
                                                        minWidth: 100,
                                                        flex: 1,
                                                        renderCell: (params) => (
                                                            <div
                                                                dangerouslySetInnerHTML={{ __html: params.value }}
                                                                style={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}
                                                            />
                                                        )
                                                    },
                                                    {
                                                        field: "createdAt",
                                                        headerName: t("-1", "Sent Date"),
                                                        valueFormatter: ({ value }) =>
                                                            value ? moment(value).format("DD-MMMM-YYYY (hh:mm A)") : "",
                                                        headerClassName: "text-white bg-primary rounded-0",
                                                        minWidth: 100,
                                                        flex: 1,
                                                    },
                                                ]}
                                            />
                                        </div>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    </TabPanel>

                    <TabPanel value={value} index={1}>
                        <div className="pb-2">
                            <Accordion expanded={emailAccordion} style={{ border: "1px solid lightgray" }}>
                                <AccordionSummary
                                    expandIcon={
                                        <IconButton onClick={toggleEmailAccordion}>
                                            {emailAccordion ? (
                                                <RemoveCircleIcon sx={{ color: "#FF7954" }} />
                                            ) : (
                                                <AddCircleIcon sx={{ color: "#FF7954" }} />
                                            )}
                                        </IconButton>
                                    }>
                                    <div className="d-flex px-1 w-100 ">
                                        <div className="card-title1 lh-1">{t("-1", "Emails Log")}</div>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className="card card-woah border border-secondary shadow rounded-0 mt-0">
                                        <div className="card-body p-4">
                                            <DataTable
                                                isLoading={false}
                                                getRowId={(row) => row.id}
                                                className="text-white bg-primary rounded-0"
                                                rows={emailData}
                                                columns={[
                                                    {
                                                        field: "sr",
                                                        headerName: t("-1", "#"),
                                                        headerClassName: "text-white bg-primary rounded-0",
                                                        flex: 1,
                                                    },
                                                    {
                                                        field: "subject",
                                                        headerName: t("-1", "Subject"),
                                                        headerClassName: "text-white bg-primary rounded-0",
                                                        minWidth: 150,
                                                        flex: 1,
                                                    },
                                                    {
                                                        field: "from",
                                                        headerName: t("-1", "Email From"),
                                                        headerClassName: "text-white bg-primary rounded-0",
                                                        minWidth: 100,
                                                        flex: 1,
                                                    },
                                                    {
                                                        field: "to",
                                                        headerName: t("-1", "Email To"),
                                                        headerClassName: "text-white bg-primary rounded-0",
                                                        minWidth: 100,
                                                        flex: 1,
                                                    },
                                                    {
                                                        field: "body",
                                                        headerName: t("-1", "Email Body"),
                                                        headerClassName: "text-white bg-primary rounded-0",
                                                        minWidth: 100,
                                                        flex: 1,
                                                        renderCell: (params) => (
                                                            <div
                                                                dangerouslySetInnerHTML={{ __html: params.value }}
                                                                style={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}
                                                            />
                                                        )
                                                    },
                                                    {
                                                        field: "createdAt",
                                                        headerName: t("-1", "Sent Date"),
                                                        valueGetter: ({ value }) => (!empty(value) ? value : null),
                                                        valueFormatter: ({ value }) =>
                                                            !empty(value)
                                                                ? moment(value).format("DD-MMMM-YYYY (hh:mm A)")
                                                                : "",
                                                        headerClassName: "text-white bg-primary rounded-0",
                                                        minWidth: 100,
                                                        flex: 1,
                                                    },
                                                ]}
                                            />
                                        </div>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    </TabPanel>

                    <TabPanel value={value} index={2}>
                        <div className="pb-2">
                            <Accordion expanded={true} style={{ border: "1px solid lightgray" }}>
                                <AccordionSummary
                                    expandIcon={<RemoveCircleIcon sx={{ color: "#FF7954" }} />}
                                    aria-controls="panel3-content"
                                    id="panel3-header"
                                    className="fs-4"
                                >
                                    <div className="d-flex px-1 w-100 ">
                                        <div className="card-title1 lh-1">{t("-1", "Mission History Log")}</div>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className="card card-woah border border-secondary shadow rounded-0 mt-0">
                                        <div className="card-body p-4">
                                           <DataTable
                                            isLoading={missionHistoryLoading}
                                            getRowId={(row) => row.id}
                                            className="text-white bg-primary rounded-0"
                                            rows={missionHistoryData.map((row, idx) => ({ ...row, sr: idx + 1 }))}
                                            columns={[
                                                { field: "sr", headerName: t("-1", "#"), headerClassName: "text-white bg-primary rounded-0", flex: 0.5 },
                                                { field: "column_name", headerName: t("-1", "Column Name"), headerClassName: "text-white bg-primary rounded-0", flex: 1 },
                                                { field: "old_value", headerName: t("-1", "Old Value"), headerClassName: "text-white bg-primary rounded-0", flex: 1 },
                                                { field: "new_value", headerName: t("-1", "New Value"), headerClassName: "text-white bg-primary rounded-0", flex: 1 },
                                                { field: "createdBy", headerName: t("-1", "Created By"), headerClassName: "text-white bg-primary rounded-0", flex: 1 },
                                                { field: "createdAt", headerName: t("-1", "Date"), valueFormatter: ({ value }) => value ? moment(value).format("DD-MMMM-YYYY (hh:mm A)") : "", headerClassName: "text-white bg-primary rounded-0", flex: 1 },
                                            ]}
                                        />
                                        </div>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        <div className="pb-2">
                            <Accordion expanded={true} style={{ border: "1px solid lightgray" }}>
                                <AccordionSummary
                                    expandIcon={<RemoveCircleIcon sx={{ color: "#FF7954" }} />}
                                    aria-controls="panel4-content"
                                    id="panel4-header"
                                    className="fs-4"
                                >
                                    <div className="d-flex px-1 w-100 ">
                                        <div className="card-title1 lh-1">{t("-1", "Document History Log")}</div>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className="card card-woah border border-secondary shadow rounded-0 mt-0">
                                        <div className="card-body p-4">
                                            <DataTable
                                                isLoading={documentHistoryLoading}
                                                getRowId={(row) => row.id}
                                                className="text-white bg-primary rounded-0"
                                                rows={documentHistoryData}
                                                columns={[
                                                { field: "sr", headerName: t("-1", "#"), headerClassName: "text-white bg-primary rounded-0", flex: 0.5 },
                                                { field: "column_name", headerName: t("-1", "Column Name"), headerClassName: "text-white bg-primary rounded-0", flex: 1 },
                                                { field: "old_value", headerName: t("-1", "Old Value"), headerClassName: "text-white bg-primary rounded-0", flex: 1 },
                                                { field: "new_value", headerName: t("-1", "New Value"), headerClassName: "text-white bg-primary rounded-0", flex: 1 },
                                                { field: "createdBy", headerName: t("-1", "Created By"), headerClassName: "text-white bg-primary rounded-0", flex: 1 },
                                                { field: "createdAt", headerName: t("-1", "Date"), valueFormatter: ({ value }) => value ? moment(value).format("DD-MMMM-YYYY (hh:mm A)") : "", headerClassName: "text-white bg-primary rounded-0", flex: 1 },
                                            ]}
                                            />
                                        </div>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    </TabPanel>
                </>
            )}
        </div>

    );
};

export default EmailNotificationLogs;
